import React from 'react';

import {Text} from '@albert-io/atomic';

import {STATUS_SEGMENTS} from './constants';
import type {SkillPathStatusSegment} from './types';

/**
 * The status a tab names. All names none, so its empty copy drops the word rather than reading
 * "No All Skill Paths".
 */
export const statusLabel = (segment: SkillPathStatusSegment): string =>
  segment === 'all' ? '' : (STATUS_SEGMENTS.find((s) => s.value === segment)?.label ?? '');

export const noneCopy = (label: string, noun: string): string =>
  label ? `No ${label} ${noun}` : `No ${noun}`;

export const SkillPathStatusEmptyLine = ({segment}: {segment: SkillPathStatusSegment}) => (
  <Text color='secondary'>{noneCopy(statusLabel(segment).toLowerCase(), 'skill paths')}</Text>
);
